import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { WAREHOUSE_ALLOCATION_ACTION_TYPE } from '../actions';

const initialState = {
  allocations: [],
  selectedAllocation: null,
  loanAllocation: null,
  curtailments: [],
  curtailmentRules: [],
};

const warehouseAllocationsReducer = (state = initialState, { type, payload, meta }) =>
  produce(state, draft => {
    switch (type) {
      case WAREHOUSE_ALLOCATION_ACTION_TYPE.GET_ALLOCATIONS_BY_LINE:
        draft.allocations = payload || [];
        break;

      case WAREHOUSE_ALLOCATION_ACTION_TYPE.GET_ALLOCATION:
        draft.selectedAllocation = payload;
        break;

      case WAREHOUSE_ALLOCATION_ACTION_TYPE.GET_ALLOCATION_BY_LOAN:
        draft.loanAllocation = payload;
        break;

      case WAREHOUSE_ALLOCATION_ACTION_TYPE.CREATE_ALLOCATION:
        draft.allocations.push(payload);
        break;

      case WAREHOUSE_ALLOCATION_ACTION_TYPE.TRANSITION_ALLOCATION_STATUS:
        draft.selectedAllocation = payload;
        draft.allocations = draft.allocations.map(a => (a.id === payload.id ? payload : a));
        break;

      case WAREHOUSE_ALLOCATION_ACTION_TYPE.DELETE_ALLOCATION:
        draft.allocations = draft.allocations.filter(a => a.id !== meta?.allocationId);
        draft.selectedAllocation = null;
        break;

      case WAREHOUSE_ALLOCATION_ACTION_TYPE.GET_CURTAILMENTS:
        draft.curtailments = payload || [];
        break;

      case WAREHOUSE_ALLOCATION_ACTION_TYPE.RECORD_CURTAILMENT_PAYMENT:
        draft.curtailments = draft.curtailments.map(c => (c.id === payload.id ? payload : c));
        break;

      case WAREHOUSE_ALLOCATION_ACTION_TYPE.GET_CURTAILMENT_RULES:
        draft.curtailmentRules = payload || [];
        break;

      case WAREHOUSE_ALLOCATION_ACTION_TYPE.MANAGE_CURTAILMENT_RULES:
        draft.curtailmentRules = payload || [];
        break;

      case WAREHOUSE_ALLOCATION_ACTION_TYPE.CLEAR_ALLOCATIONS:
      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default warehouseAllocationsReducer;
